/**
 * OAuth helpers — redirige al backend tax-account /oauth/{provider}/start.
 *
 * El backend valida con el proveedor (Google/Microsoft), recibe el callback
 * y nos redirige a `${APP_URL}/auth/oauth/callback#access_token=...`.
 * La página OAuthCallbackPage parsea el hash + setea token + redirect.
 */

import { APP } from './constants'

export type OAuthProvider = 'google' | 'microsoft'

/**
 * Redirect del browser al endpoint OAuth start del backend.
 * Para login (default) o registro.
 */
export function startOAuth(
  provider: OAuthProvider,
  intent: 'login' | 'register' = 'login',
): void {
  const url = `${APP.accountUrl}/api/v1/auth/oauth/${provider}/start?intent=${intent}`
  window.location.href = url
}
